const sessionStorageKeyPrefix = `cvco.smart.connection.`;

export function getActiveChatbotSessionLocale(): string | undefined {
  return (
    Object.keys(window.sessionStorage)
      .find((key) => key.startsWith(sessionStorageKeyPrefix))
      ?.replace(sessionStorageKeyPrefix, ``) || undefined
  );
}
